import "../_candidato/priv/index"
import "../_candidato/public/index"
import "../_candidato/debug/index"
import angular from "angular"

export var $app = angular.module("CandidatoPlay", //
    [ //
        "candidato",
        "candidatoPublic",
        "ui.router", //..
    ])

$app.config(function(toastrConfig: ng.toastr.IToastContainerConfig) {
    angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: "toast-container",
        maxOpened: 0,
        newestOnTop: true,
        positionClass: "toast-bottom-right",
        preventDuplicates: false,
        preventOpenDuplicates: false,
        target: "body"
    })
})